<template>
  <!-- <div class="row"> -->
    <TextStudy ref="studyText" @wordClicked="onWordClicked" class="col-sm-6" :backendURL="backendURL"/>
    <CognateSearch ref="cognateSearcher" class="col-sm-6" :backendURL="backendURL"/>
  <!-- </div> -->
</template>

<script>
// import axios from 'axios';
import TextStudy from './TextStudy.vue';
import CognateSearch from './CognateSearch.vue';

export default {
  name: 'SiprComponent',
  props: {
    backendURL: String,
  },
  components: {
    TextStudy,
    CognateSearch,
  },
  methods: {
    onWordClicked(word) {
      this.$refs.cognateSearcher.searchString = word;
      this.$refs.cognateSearcher.search();
    }
  },
  mounted() {
    // axios.get(this.backendURL);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hebrew {
  font-size: 1.5em;
}

.clickable:hover {
  cursor: pointer;
  background-color: yellow;
}
</style>
